import { render, staticRenderFns } from "./PedidoCreate.vue?vue&type=template&id=5b2f3eeb"
import script from "./PedidoCreate.vue?vue&type=script&lang=js"
export * from "./PedidoCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports